module.exports = __webpack_public_path__ + "img/slack.d07f5991.svg";